module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bloc b-divider bgc-white l-bloc",
    attrs: {
      "id": "bloc-319"
    }
  }, [_c('div', {
    staticClass: "container bloc-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('h3', {
    staticClass: "mg-md"
  }, [_vm._v("\n\t\t\t\t\tLöydä toimittajia\n\t\t\t\t")]), _c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Selaa kaikkia")]), _c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Toimittajat Helsinki")]), _c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Toimittajat Espoo")]), _c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Toimittajat Tampere")]), _c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Toimittajat Vantaa")]), _c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Toimittajat Oulu")]), _c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Toimittajat Turku")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('h3', {
    staticClass: "mg-md"
  }, [_vm._v("\n\t\t\t\t\tTutustu tarkemmin"), _c('br')]), _c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Kuinka palvelu toimii?")]), _c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "email-landing.html"
    }
  }, [_vm._v("UKK rakentajille")]), _c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "dash-toimittaja.html"
    }
  }, [_vm._v("UKK toimittajat")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('h3', {
    staticClass: "mg-md"
  }, [_vm._v("\n\t\t\t\t\tYritys\n\t\t\t\t")]), _c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Käyttöehdot")]), _c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Yksityisyys")]), _c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Turvallisuus")]), _c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Ota yhteyttä")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('h3', {
    staticClass: "mg-md"
  }, [_vm._v("\n\t\t\t\t\tSeuraa meitä\n\t\t\t\t")]), _c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Facebook")]), _c('a', {
    staticClass: "a-btn a-block",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Twitter")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6f767f53"}!./src/app/components/footer/footer.html
// module id = 488
// module chunks = 1